import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

export default function Responsive({ children }) {

    const [isClient, setIsClient] = useState(false);
    const isMobile = useMediaQuery({maxWidth: '820px'})

    useEffect(() => {
        if (typeof window !== "undefined") {
            setIsClient(true)
        }
    }, [])

    if (isClient && isMobile) {
        return (
            <div>
                {children}
            </div>
        )
    }

    return children

}